type CheckboxSvg = {
    svg: string,
    width: number,
    height: number,
    margin: number,
}

export function checkboxSvg(checked: boolean, size = 12): CheckboxSvg {
    const svg = checked
        ? `
<svg width="${size}" height="${size}" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width="11" height="11" fill="none" stroke="black"/>
  <line x1="2" y1="2" x2="10" y2="10" stroke="black" stroke-width="1"/>
  <line x1="2" y1="10" x2="10" y2="2" stroke="black" stroke-width="1"/>
</svg>`
        : `
<svg width="${size}" height="${size}" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width="11" height="11" fill="none" stroke="black"/>
</svg>`;

    return {
        svg,
        width: size,
        height: size,
        margin: 2,
    };
}
